/**
 * 道路导航区（NAVIGATION）枚举工具
 *
 * 职责：
 * 1. 将后端返回的 name/code 枚举转换为 antd Select/Radio 的 options 格式
 * 2. 提供显示用的 label 转换函数
 *
 * 后端枚举 key：
 * - NAVIGATION_TOPOLOGY：拓扑关系
 * - NAVIGATION_DIRECTION：行驶方向
 */
export const NAVIGATION_TOPOLOGY_ENUM_KEY = 'NAVIGATION_TOPOLOGY';
export const NAVIGATION_DIRECTION_ENUM_KEY = 'NAVIGATION_DIRECTION';

export type MapEnumItem = {
  name: string;
  code: string;
};

export type NavigationEnumOptions = {
  topology: Array<{ label: string; value: string }>;
  direction: Array<{ label: string; value: string }>;
};

export const emptyNavigationEnumOptions: NavigationEnumOptions = {
  topology: [],
  direction: [],
};

const toOptions = (items?: MapEnumItem[]) =>
  (items ?? []).map(({ name, code }) => ({ label: name, value: code }));

export const getNavigationEnumOptions = (
  data?: Record<string, MapEnumItem[]>
): NavigationEnumOptions => ({
  topology: toOptions(data?.[NAVIGATION_TOPOLOGY_ENUM_KEY]),
  direction: toOptions(data?.[NAVIGATION_DIRECTION_ENUM_KEY]),
});

export const hasNavigationEnumOptions = (options: NavigationEnumOptions) =>
  options.topology.length > 0 && options.direction.length > 0;

export const getNavigationEnumLabel = (
  options: Array<{ label: string; value: string }>,
  code?: string
) => options.find((item) => item.value === code)?.label ?? code ?? '-';

export const getNavigationDirectionLabels = (
  options: Array<{ label: string; value: string }>,
  codes?: string[]
) =>
  (codes ?? []).map((code) => getNavigationEnumLabel(options, code)).join('、');
